<template>
    <transition name="fade"> 
        <div class="charge-success">
            <div class="charge-success-body">
                <div class="close-icon" @click="onChargeFinish">
                    <Icon type="md-close"></Icon>
                </div>
                <div class="charge-success-icon"></div>
                <div class="charge-success-text">充值成功</div>
                <div class="charge-success-amount-text">您的账号已成功充值<span>¥{{amount}}</span></div>
                <div class="btn-box">
                    <div class="detail-btn" @click="onDetailClick">查看明细</div>
                    <div class="confirm-btn" @click="onChargeFinish">完成</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    name:"ChargeSuccess",
    data(){
        return{}
    },
    props:{
        amount:{
            type:Number | String,
            default:0
        }
    },
    mounted(){
        console.log('charge-success-mounted');
        //>充值完成更新用户数据
        this.$store.dispatch('getUser');
    },
    methods:{
        onDetailClick(){
            this.onChargeFinish();
            this.$router.push({name:'UserBalance'});
        },
        onChargeFinish(){
            this.$emit('close-charge-success');
        }
    }
}
</script>
<style lang="scss" scoped>
.charge-success{
    width: 100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    z-index:102;
    display:flex;
    align-items:center;
    justify-content:center;
    .charge-success-body{
        width:500px;
        height:340px;
        background:#ffffff;
        border-radius:15px;
        position:relative;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        .close-icon{
            position:absolute;
            top: 20px;
            right: 25px;
            cursor:pointer;
        }
        .charge-success-icon{
            width:70px;
            height:70px;
            background:url('../assets/images/icon-success-green.png') no-repeat;
            background-size:cover;
            background-position:center;
        }
        .charge-success-text{
            font-size:24px;
            color:#3bb46d;
            margin-top:30px;
        }
        .charge-success-amount-text{
            color:#666666;
            font-size:16px;
            margin-top:20px;
            span{
                color:#fa3d5a;
            }
        }
        .btn-box{
            display:flex;
            align-items:center;
            column-gap:20px;
            margin-top:50px;
            .detail-btn{
                width:130px;
                height:49px;
                border-radius:5px;
                border:1px solid #fa3d5a;
                color:#fa3d5a;
                line-height:49px;
                text-align:center;
                cursor:pointer;
                background:transparent;
            }
            .confirm-btn{
                width:130px;
                height:49px;
                border-radius:5px;
                background:#fa3d5a;
                color:#ffffff;
                line-height:49px;
                text-align:center;
                cursor:pointer;
            }
        }
    }
}
</style>